import { createAsyncThunk } from '@reduxjs/toolkit'
import DataService from "../service";
import { constant } from '../constant'
const { path } = constant;
export const fetchWardList = createAsyncThunk(
    'ward/fetchWard',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+'client/ward/v1/list', rejectWithValue)
)

export const createUpdateWard = createAsyncThunk(
    'ward/createUpdateWard',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/ward/v1', rejectWithValue)
)

export const deleteWard = createAsyncThunk(
    'wards/deleteWard',
    (arg, { rejectWithValue }) => DataService.delete(arg, path+`client/ward/v1/delete/${arg?.wardId}`, rejectWithValue)
)

export const toggleActivation = createAsyncThunk(
    'wards/toggleActivation',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/ward/v1/toggle-status/${arg?.wardId}`, rejectWithValue)
)

export const getWardByWardId = createAsyncThunk(
    'wards/getWardByWardId',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/ward/v1/single/${arg?.wardId}`, rejectWithValue)
)